function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function stripHtml(text) {
  const node = document.createElement('div');
  node.innerHTML = text || '';
  return node.textContent?.trim() || '';
}

function reviewQuote(review) {
  const body = review.body?.trim();
  if (body) return body;
  return review.title?.trim() || '';
}

function reviewAuthor(review) {
  return review.author?.trim() || 'Customer';
}

function reviewSubtitle(review, mode) {
  if (mode === 'product' && review.product_title) {
    return review.product_title.trim();
  }
  if (mode === 'verified' && review.verified) {
    return 'Verified buyer';
  }
  if (mode === 'product' && review.verified) {
    return 'Verified buyer';
  }
  return '';
}

function reviewInitial(name) {
  const trimmed = String(name || '').trim();
  return trimmed ? trimmed.charAt(0).toUpperCase() : '';
}

function buildStars(rating) {
  const stars = Math.max(1, Math.min(5, Number(rating) || 5));
  let html = `<div class="bbs-testimonial-card__stars" aria-label="${stars} out of 5 stars">`;
  for (let index = 1; index <= 5; index += 1) {
    html += `<span class="material-symbols-outlined" aria-hidden="true" style="font-variation-settings: 'FILL' ${index <= stars ? 1 : 0};">star</span>`;
  }
  html += '</div>';
  return html;
}

function buildTestimonialCard(review, subtitleMode, showImage) {
  const quote = reviewQuote(review);
  const author = reviewAuthor(review);
  const subtitle = reviewSubtitle(review, subtitleMode);
  const avatarUrl = review.avatar || '';
  const initial = reviewInitial(author);
  const imageUrl = showImage ? review.image || '' : '';

  let authorMarkup = '<div class="bbs-testimonial-card__author">';
  if (avatarUrl) {
    authorMarkup += `<img class="bbs-testimonial-card__avatar-image" src="${escapeHtml(avatarUrl)}" alt="${escapeHtml(author)}" loading="lazy" width="40" height="40">`;
  } else if (initial) {
    authorMarkup += `<span class="bbs-testimonial-card__avatar" aria-hidden="true">${escapeHtml(initial)}</span>`;
  }

  authorMarkup += '<div class="bbs-testimonial-card__meta">';
  authorMarkup += `<p class="bbs-label-caps bbs-testimonial-card__name">${escapeHtml(author)}</p>`;
  if (subtitle) {
    authorMarkup += `<p class="bbs-testimonial-card__subtitle">${escapeHtml(subtitle)}</p>`;
  }
  authorMarkup += '</div></div>';

  const imageMarkup = showImage
    ? imageUrl
      ? `<div class="bbs-testimonial-card__media"><img class="bbs-testimonial-card__media-image" src="${escapeHtml(imageUrl)}" alt="" loading="lazy" width="320" height="320"></div>`
      : '<div class="bbs-testimonial-card__media bbs-testimonial-card__media--empty" aria-hidden="true"></div>'
    : '';

  return `
    <article class="bbs-testimonial-card">
      ${imageMarkup}
      ${buildStars(review.rating)}
      ${quote ? `<blockquote class="bbs-testimonial-card__quote">${escapeHtml(quote)}</blockquote>` : ''}
      ${authorMarkup}
    </article>
  `;
}

function isCloneElement(element) {
  return (
    element.classList.contains('jdgm-clone-before') ||
    element.classList.contains('jdgm-clone-after') ||
    element.classList.contains('jdgm-cloned')
  );
}

function resolveImageUrl(value) {
  if (!value) return '';
  if (typeof value === 'string') {
    return /^https?:\/\//.test(value) ? value : '';
  }
  if (typeof value === 'object') {
    const candidate = value.compact || value.small || value.original || value.huge || value.url || '';
    return typeof candidate === 'string' && /^https?:\/\//.test(candidate) ? candidate : '';
  }
  return '';
}

function resolveAvatarUrl(review) {
  return (
    resolveImageUrl(review.avatar_image_url) ||
    resolveImageUrl(review.avatar) ||
    resolveImageUrl(review.reviewer_avatar_url) ||
    ''
  );
}

function resolveReviewImageUrl(review) {
  const pictures = review.pictures_urls || review.picture_urls || [];
  if (Array.isArray(pictures) && pictures.length) {
    const fromList = resolveImageUrl(pictures[0]);
    if (fromList) return fromList;
  }

  return (
    resolveImageUrl(review.picture_url) ||
    resolveImageUrl(review.media_url) ||
    resolveImageUrl(review.image_url) ||
    ''
  );
}

function normalizeReview(review) {
  const body = review.body || stripHtml(review.body_html);

  return {
    rating: Number(review.rating) || 5,
    body: String(body || '').trim(),
    title: String(review.title || '').trim(),
    author: String(review.reviewer_name || review.name || review.reviewer?.name || '').trim(),
    product_title: String(review.product_title || review.product?.title || '').trim(),
    verified: !!(review.verified || review.verified_buyer),
    avatar: resolveAvatarUrl(review),
    image: resolveReviewImageUrl(review),
    pinned: !!(review.pinned || review.featured)
  };
}

function parseReviewsFromCarouselMode(blockId) {
  const reviews = window.jdgmCarouselMode?.[blockId]?.reviews;
  if (!Array.isArray(reviews) || !reviews.length) return [];
  return reviews.map(normalizeReview);
}

function parseReviewsFromDom(container) {
  const seen = new Set();

  return Array.from(container.querySelectorAll('.jdgm-card[data-review-id], .jdgm-carousel-item[data-review-id]'))
    .filter((element) => !isCloneElement(element))
    .map((element) => {
      const id = element.getAttribute('data-review-id');
      if (!id || seen.has(id)) return null;
      seen.add(id);

      const mediaImage = element.querySelector('.jdgm-card-media img, .jdgm-media-card img, .jdgm-carousel-item__review-image img');

      return normalizeReview({
        rating: element.querySelectorAll('.jdgm-star.jdgm--on').length || 5,
        body:
          element.querySelector('.jdgm-text')?.textContent?.trim() ||
          element.querySelector('.jdgm-carousel-item__review-body')?.textContent?.trim() ||
          '',
        title: element.querySelector('.jdgm-carousel-item__review-title')?.textContent?.trim() || '',
        reviewer_name: element.querySelector('.jdgm-reviewer-name')?.textContent?.trim() || '',
        product_title: element.querySelector('.jdgm-product-name')?.textContent?.trim() || '',
        verified: !!element.querySelector('.jdgm-verified-badge, .jdgm-verified-checkmark, .jdgm-reviewer-verified-icon'),
        pictures_urls: mediaImage?.getAttribute('src') ? [{ original: mediaImage.getAttribute('src') }] : [],
        pinned: element.getAttribute('data-pinned') === 'true'
      });
    })
    .filter(Boolean);
}

function readCarouselReviews(source) {
  const carousel = source.querySelector('.jdgm-cards-carousel');
  if (!carousel) return [];

  const blockId = carousel.dataset.jdgmBlockId || '';
  const fromMode = blockId ? parseReviewsFromCarouselMode(blockId) : [];
  if (fromMode.length) return fromMode;

  return parseReviewsFromDom(source);
}

function filterParsedReviews(reviews, root) {
  const maxReviews = Number(root.dataset.maxReviews) || 10;
  const minRating = Number(root.dataset.minRating) || 1;
  const source = root.dataset.reviewsSource || 'featured';

  let filtered = reviews.filter((review) => {
    if ((Number(review.rating) || 0) < minRating) return false;
    return reviewQuote(review) !== '';
  });

  if (source === 'featured') {
    const featured = filtered.filter((review) => review.pinned === true);
    if (featured.length > 0) {
      filtered = featured;
    }
  }

  return filtered.slice(0, maxReviews);
}

function waitForCarouselReviews(source, maxWait = 20000) {
  return new Promise((resolve, reject) => {
    const started = Date.now();
    const carousel = source.querySelector('.jdgm-cards-carousel');

    if (!carousel) {
      reject(new Error('Judge.me Cards Carousel block missing'));
      return;
    }

    const tryRead = () => {
      const reviews = readCarouselReviews(source);
      if (reviews.length > 0) {
        cleanup();
        resolve(reviews);
        return true;
      }
      return false;
    };

    const observer = new MutationObserver(() => {
      tryRead();
    });

    const interval = window.setInterval(() => {
      if (tryRead()) return;
      if (Date.now() - started > maxWait) {
        cleanup();
        reject(new Error('Judge.me Cards Carousel did not finish loading'));
      }
    }, 300);

    const cleanup = () => {
      observer.disconnect();
      window.clearInterval(interval);
    };

    observer.observe(source, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    tryRead();
  });
}

async function fetchReviewsFromCarouselBlock(root) {
  const source = root.querySelector('[data-bbs-judgeme-source]');
  if (!source) {
    throw new Error('Judge.me source container missing');
  }

  const reviews = await waitForCarouselReviews(source);
  return filterParsedReviews(reviews, root);
}

function setTestimonialsMessage(root, message, className = 'bbs-testimonials__empty') {
  const frame = root.querySelector('[data-bbs-testimonials-frame]');
  const track = root.querySelector('[data-bbs-testimonials-track]');
  const dots = root.querySelector('[data-bbs-testimonials-dots]');
  if (!frame || !track) return;

  track.innerHTML = `<p class="${className} bbs-label-caps">${escapeHtml(message)}</p>`;
  frame.classList.remove('bbs-testimonials__frame--carousel', 'bbs-testimonials__frame--active');
  frame.removeAttribute('data-bbs-testimonials-carousel');
  delete frame.dataset.bbsCarouselInit;
  if (dots) {
    dots.hidden = true;
    dots.innerHTML = '';
  }
}

function initTestimonialsCarousel(root) {
  const frame = root.querySelector('[data-bbs-testimonials-frame]');
  if (!frame) return;

  const cardCount = root.querySelectorAll('.bbs-testimonial-card').length;
  const columnsDesktop = Number(root.dataset.columnsDesktop) || 2;
  const enableCarousel = root.dataset.enableCarousel === 'true';
  const useCarousel = enableCarousel && cardCount > columnsDesktop;

  frame.style.setProperty('--bbs-testimonials-columns', String(columnsDesktop));
  frame.classList.toggle('bbs-testimonials__frame--carousel', useCarousel);

  if (useCarousel) {
    frame.setAttribute('data-bbs-testimonials-carousel', '');
    frame.setAttribute('data-autoplay', root.dataset.autoplay || 'true');
    frame.setAttribute('data-autoplay-interval', root.dataset.autoplayInterval || '5000');
  } else {
    frame.removeAttribute('data-bbs-testimonials-carousel');
  }

  delete frame.dataset.bbsCarouselInit;
  window.BBSScanHomepageCarousels?.(root);
}

async function loadJudgeMeTestimonials(root) {
  if (!root || root.dataset.judgemeLoaded === 'true') return;

  const source = root.querySelector('[data-bbs-judgeme-source]');
  if (!source) return;

  root.dataset.judgemeLoaded = 'true';

  const track = root.querySelector('[data-bbs-testimonials-track]');
  const subtitleMode = root.dataset.subtitleMode || 'product';
  const showImage = root.dataset.showImage === 'true';

  if (!track) return;

  try {
    const reviews = await fetchReviewsFromCarouselBlock(root);
    if (!reviews.length) {
      setTestimonialsMessage(root, root.dataset.emptyMessage || 'No reviews found.');
      return;
    }

    track.innerHTML = reviews.map((review) => buildTestimonialCard(review, subtitleMode, showImage)).join('');
    initTestimonialsCarousel(root);
  } catch (error) {
    console.error('BBS Judge.me testimonials failed', error);
    const fallback = root.dataset.errorMessage || 'Unable to load reviews from Judge.me.';
    setTestimonialsMessage(root, fallback);
  }
}

function initJudgeMeTestimonials(scope = document) {
  scope.querySelectorAll('[data-bbs-testimonials-judgeme]').forEach((root) => {
    if (root.dataset.judgemeInit === 'true') return;
    root.dataset.judgemeInit = 'true';
    loadJudgeMeTestimonials(root);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initJudgeMeTestimonials();
});

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector?.('[data-bbs-testimonials-judgeme]') || event.target;
  if (root?.dataset) {
    root.dataset.judgemeInit = '';
    root.dataset.judgemeLoaded = '';
  }
  initJudgeMeTestimonials(event.target);
});
